import React, {useState} from "react";
export default (props) => {
	const [input1, onChangeInput1] = useState('');
	const [input2, onChangeInput2] = useState('');
	const [input3, onChangeInput3] = useState('');
	const [input4, onChangeInput4] = useState('');
	const [input5, onChangeInput5] = useState('');
	const [input6, onChangeInput6] = useState('');
	const [input7, onChangeInput7] = useState('');
	return (
		<div 
			style={{
				display: "flex",
				flexDirection: "column",
				background: "#FFFFFF",
			}}>
			<div 
				style={{
					height: 2755,
					alignSelf: "stretch",
					background: "#F6F7F9",
				}}>
				<div 
					style={{
						alignSelf: "stretch",
						display: "flex",
						flexDirection: "column",
						alignItems: "flex-start",
					}}>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "flex-start",
							position: "relative",
						}}>
						{/* <div 
							style={{
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								paddingTop: 32,
								paddingBottom: 684,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/hlxuw8sn_expires_30_days.png"} 
								style={{
									width: 80,
									height: 80,
									marginBottom: 16,
									marginLeft: 32,
									objectFit: "fill",
								}}
							/>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									marginBottom: 14,
									marginLeft: 32,
									gap: 13,
								}}>
								<span 
									style={{
										color: "#2C2C2C",
										fontSize: 18,
										fontWeight: "bold",
									}} >
									{"John Doe"}
								</span>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										background: "linear-gradient(180deg, #F57E47, #F36421)",
										borderRadius: 3,
										paddingTop: 1,
										paddingLeft: 6,
										paddingRight: 6,
									}}>
									<span 
										style={{
											color: "#FFFFFF",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"Mentor"}
									</span>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									paddingRight: 1,
									marginBottom: 64,
									marginLeft: 32,
									marginRight: 32,
									gap: 6,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/tr6l5l7s_expires_30_days.png"} 
									style={{
										width: 15,
										height: 15,
										objectFit: "fill",
									}}
								/>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 12,
									}} >
									{"johndoe123@email.com"}
								</span>
							</div>
							<span 
								style={{
									color: "#979797",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 22,
									marginLeft: 32,
								}} >
								{"MAIN MENU"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									paddingTop: 10,
									paddingBottom: 10,
									paddingLeft: 12,
									paddingRight: 12,
									marginBottom: 30,
									marginLeft: 20,
									gap: 12,
								}}>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/4ymuixsc_expires_30_days.png"} 
									style={{
										width: 23,
										height: 23,
										objectFit: "fill",
									}}
								/>
								<input
									placeholder={"Dashboard"}
									value={input1}
									onChange={(event)=>onChangeInput1(event.target.value)}
									style={{
										color: "#FFFFFF",
										fontSize: 16,
										fontWeight: "bold",
										width: 80,
										background: "none",
										border: "none",
										paddingTop: 2,
										paddingBottom: 2,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "flex-start",
									marginLeft: 32,
									gap: 40,
								}}>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/iynyuybx_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Mentees"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 4,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/44njctp4_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Requests"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/s6kxit45_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Chats"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/k1ppja6m_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Community"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/axm5ed89_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Notifications"}
									</span>
								</div>
								<div 
									style={{
										display: "flex",
										alignItems: "center",
										paddingRight: 3,
										gap: 12,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/jzcvvro8_expires_30_days.png"} 
										style={{
											width: 23,
											height: 23,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#6C6C6C",
											fontSize: 16,
										}} >
										{"Settings"}
									</span>
								</div>
							</div>
						</div> */}
						<div 
							style={{
								position: "absolute",
								top: 211,
								left: 0,
								width: 236,
								height: 1,
								background: "#E6E6E6",
							}}>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "center",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 33,
							paddingRight: 33,
							marginBottom: 32,
							marginLeft: 234,
						}}>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#F6F7F9",
								borderRadius: 8,
								paddingTop: 14,
								paddingBottom: 14,
								paddingLeft: 20,
								paddingRight: 20,
								marginRight: 257,
								gap: 12,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/v5szau4c_expires_30_days.png"} 
								style={{
									width: 21,
									height: 21,
									objectFit: "fill",
								}}
							/>
							<input
								placeholder={"For quick access to courses, mentors, or posts"}
								value={input2}
								onChange={(event)=>onChangeInput2(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									width: 306,
									background: "none",
									border: "none",
									paddingTop: 2,
									paddingBottom: 2,
								}}
							/>
						</div>
						<div 
							style={{
								flexShrink: 0,
								display: "flex",
								alignItems: "center",
								background: "#FEF0E9",
								borderRadius: 8,
								paddingTop: 10,
								paddingBottom: 10,
								paddingLeft: 20,
								paddingRight: 23,
								marginRight: 32,
								gap: 8,
							}}>
							<img
								src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/evxn3lm1_expires_30_days.png"} 
								style={{
									width: 32,
									height: 32,
									objectFit: "fill",
								}}
							/>
							<span 
								style={{
									color: "#F57E47",
									fontSize: 17,
									fontWeight: "bold",
								}} >
								{"Ask Giia"}
							</span>
						</div>
						<div 
							style={{
								width: 1,
								height: 58,
								background: "#E6E6E6",
								marginRight: 31,
							}}>
						</div>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/llx4h5lp_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								marginRight: 24,
								objectFit: "fill",
							}}
						/>
						<img
							src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/1vc4q5rw_expires_30_days.png"} 
							style={{
								width: 24,
								height: 24,
								objectFit: "fill",
							}}
						/>
					</div>
					<span 
						style={{
							color: "#010101",
							fontSize: 40,
							fontWeight: "bold",
							marginBottom: 32,
							marginLeft: 267,
						}} >
						{"Create Certificate"}
					</span>
					<div 
						style={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							marginBottom: 33,
							marginLeft: 673,
							position: "relative",
						}}>
						<div 
							style={{
								width: 1,
								height: 1078,
								background: "#E6E6E6",
							}}>
						</div>
						<div 
							style={{
								position: "absolute",
								bottom: 0,
								left: -406,
								width: 1141,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
								background: "#FFFFFF",
								borderRadius: 12,
								boxShadow: "0px 1px 3px #00000003",
							}}>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginTop: 19,
									marginBottom: 11,
									marginLeft: 20,
								}}>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 275,
									}} >
									{"Create Certificate"}
								</span>
								<span 
									style={{
										color: "#979797",
										fontSize: 16,
										fontWeight: "bold",
										marginRight: 504,
									}} >
									{"Schedule a Meeting"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/ugg7usnc_expires_30_days.png"} 
									style={{
										width: 10,
										height: 10,
										marginTop: 13,
										objectFit: "fill",
									}}
								/>
							</div>
							<div 
								style={{
									alignSelf: "stretch",
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 18,
									marginLeft: 20,
									marginRight: 20,
									gap: 48,
								}}>
								<div 
									style={{
										width: 362,
										height: 1,
										background: "#E6E6E6",
									}}>
								</div>
								<div 
									style={{
										height: 1,
										flex: 1,
										background: "#E6E6E6",
									}}>
								</div>
							</div>
							<div 
								style={{
									display: "flex",
									alignItems: "flex-start",
									marginBottom: 6,
									marginLeft: 20,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										flexDirection: "column",
										alignItems: "flex-start",
										marginRight: 68,
									}}>
									<span 
										style={{
											color: "#010101",
											fontSize: 20,
											fontWeight: "bold",
											marginBottom: 32,
											width: 342,
										}} >
										{"Generate a certificate of completion or participation."}
									</span>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
											marginBottom: 12,
										}} >
										{"Learner’s Full Name"}
									</span>
									<input
										placeholder={"Enter learner name"}
										value={input3}
										onChange={(event)=>onChangeInput3(event.target.value)}
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											marginBottom: 20,
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											paddingTop: 16,
											paddingBottom: 16,
											paddingLeft: 20,
											paddingRight: 20,
										}}
									/>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
											marginBottom: 12,
										}} >
										{"Certificate Title"}
									</span>
									<input
										placeholder={"Enter certificate title"}
										value={input4}
										onChange={(event)=>onChangeInput4(event.target.value)}
										style={{
											color: "#6C6C6C",
											fontSize: 14,
											marginBottom: 20,
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											paddingTop: 16,
											paddingBottom: 16,
											paddingLeft: 20,
											paddingRight: 20,
										}}
									/>
									<span 
										style={{
											color: "#2C2C2C",
											fontSize: 12,
											fontWeight: "bold",
											marginBottom: 12,
										}} >
										{"Description"}
									</span>
									<div 
										style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "flex-start",
											background: "#FFFFFF",
											borderRadius: 8,
											border: `1px solid #E6E6E6`,
											paddingTop: 20,
											paddingBottom: 60,
											paddingLeft: 20,
											paddingRight: 62,
										}}>
										<span 
											style={{
												color: "#6C6C6C",
												fontSize: 14,
												width: 280,
											}} >
											{"This certifies that [Name] has successfully completed…"}
										</span>
									</div>
								</div>
								<div 
									style={{
										width: 640,
										height: 420,
										background: "#F6F7F9",
										borderRadius: 12,
										marginTop: 21,
									}}>
								</div>
							</div>
							<span 
								style={{
									color: "#2C2C2C",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 12,
									marginLeft: 20,
								}} >
								{"Course Name"}
							</span>
							<input
								placeholder={"Enter course"}
								value={input5}
								onChange={(event)=>onChangeInput5(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									marginBottom: 20,
									marginLeft: 20,
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 20,
									paddingRight: 20,
								}}
							/>
							<span 
								style={{
									color: "#2C2C2C",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 12,
									marginLeft: 20,
								}} >
								{"Completion Date"}
							</span>
							<button 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 20,
									paddingRight: 20,
									marginBottom: 20,
									marginLeft: 20,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 155,
									}} >
									{"Select completion date"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/8j5470qo_expires_30_days.png"} 
									style={{
										width: 17,
										height: 17,
										objectFit: "fill",
									}}
								/>
							</button>
							<span 
								style={{
									color: "#2C2C2C",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 12,
									marginLeft: 20,
								}} >
								{"Mentor Name"}
							</span>
							<input
								placeholder={"Enter mentor name"}
								value={input6}
								onChange={(event)=>onChangeInput6(event.target.value)}
								style={{
									color: "#6C6C6C",
									fontSize: 14,
									marginBottom: 20,
									marginLeft: 20,
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 20,
									paddingRight: 20,
								}}
							/>
							<span 
								style={{
									color: "#2C2C2C",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 12,
									marginLeft: 20,
								}} >
								{"Date of Issue"}
							</span>
							<button 
								style={{
									display: "flex",
									alignItems: "flex-start",
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 16,
									paddingBottom: 16,
									paddingLeft: 20,
									paddingRight: 20,
									marginBottom: 20,
									marginLeft: 20,
									textAlign: "left",
								}}
								onClick={()=>alert("Pressed!")}>
								<span 
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										marginRight: 176,
									}} >
									{"Select date of issue"}
								</span>
								<img
									src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/g8kgt6p9_expires_30_days.png"} 
									style={{
										width: 17,
										height: 17,
										objectFit: "fill",
									}}
								/>
							</button>
							<span 
								style={{
									color: "#2C2C2C",
									fontSize: 12,
									fontWeight: "bold",
									marginBottom: 12,
									marginLeft: 20,
								}} >
								{"Add Signature"}
							</span>
							<div 
								style={{
									display: "flex",
									alignItems: "center",
									background: "#FFFFFF",
									borderRadius: 8,
									border: `1px solid #E6E6E6`,
									paddingTop: 11,
									paddingBottom: 11,
									paddingLeft: 16,
									paddingRight: 16,
									marginBottom: 28,
									marginLeft: 20,
									gap: 16,
								}}>
								<div 
									style={{
										flexShrink: 0,
										display: "flex",
										alignItems: "flex-start",
										background: "#F1F2F4",
										borderRadius: 6,
										paddingTop: 8,
										paddingBottom: 8,
										paddingLeft: 12,
										paddingRight: 12,
										gap: 4,
									}}>
									<img
										src={"https://storage.googleapis.com/tagjs-prod.appspot.com/v1/A7bYjHDBMC/mrhdjwlh_expires_30_days.png"} 
										style={{
											borderRadius: 6,
											width: 12,
											height: 12,
											objectFit: "fill",
										}}
									/>
									<span 
										style={{
											color: "#010101",
											fontSize: 10,
											fontWeight: "bold",
										}} >
										{"CHOOSE FILE"}
									</span>
								</div>
								<input
									placeholder={"Add signature file"}
									value={input7}
									onChange={(event)=>onChangeInput7(event.target.value)}
									style={{
										color: "#6C6C6C",
										fontSize: 14,
										width: 115,
										background: "none",
										border: "none",
										paddingTop: 5,
										paddingBottom: 5,
									}}
								/>
							</div>
							<div 
								style={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									background: "linear-gradient(180deg, #6BD0F6, #00AEEF)",
									borderRadius: 8,
									border: `1px solid #00000000`,
									paddingTop: 16,
									paddingBottom: 17,
									paddingLeft: 122,
									paddingRight: 122,
									marginBottom: 21,
									marginLeft: 20,
								}}>
								<span 
									style={{
										color: "#FFFFFF",
										fontSize: 14,
										fontWeight: "bold",
									}} >
									{"Submit Feedback"}
								</span>
							</div>
						</div>
					</div>
					<div 
						style={{
							display: "flex",
							alignItems: "flex-start",
							background: "#FFFFFF",
							paddingTop: 20,
							paddingBottom: 20,
							paddingLeft: 40,
							paddingRight: 40,
							marginLeft: 232,
							boxShadow: "0px -2px 4px #00000000",
						}}>
						<span 
							style={{
								color: "#979797",
								fontSize: 14,
								marginRight: 502,
							}} >
							{"© 2025 Global Impact Innovators. All Rights Reserved."}
						</span>
						<span 
							style={{
								color: "#979797",
								fontSize: 14,
								marginRight: 27,
							}} >
							{"Privacy"}
						</span>
						<span 
							style={{
								color: "#979797",
								fontSize: 14,
								marginRight: 26,
							}} >
							{"Terms of Service"}
						</span>
						<span 
							style={{
								color: "#979797",
								fontSize: 14,
							}} >
							{"Help & FAQ"}
						</span>
					</div>
				</div>
			</div>
		</div>
	)
}